import React from "react";
import { GUIDE_INFO_LABELS } from "../../Common/GuideDiff";
import "./TripAI.css";

const formatValue = (field, value) => {
  if (Array.isArray(value)) return value.length > 0 ? value.join(", ") : "(none)";
  if (value === "" || value == null) return "(empty)";
  return String(value);
};

const isPhotoField = (field) => field === "image" || field === "image_m";

// Per-field mine/theirs picker for guide-level metadata (Name, Description,
// Cover Photo, Language, Countries, Cities, Sharing) — same pattern as
// PlaceDiffCard/EventDiffCard's changed-field rows, since unlike the
// itinerary this is a handful of independently-editable fields, not one
// freeform blob. guideInfoDiff: result of GuideDiff.diffGuideInfo().
// fieldChoices: current { [field]: "mine"|"theirs" } picks.
// onFieldChoice(field, choice).
const GuideInfoDiffCard = ({ guideInfoDiff, fieldChoices, onFieldChoice }) => (
  <div className="tai-dest-card">
    <div className="tai-dest-header">
      <span className="tai-dest-title">Guide Info</span>
    </div>
    {guideInfoDiff.changedFields.map((field) => {
      const choice = fieldChoices?.[field];
      const mineVal = guideInfoDiff.local?.[field];
      const serverVal = guideInfoDiff.server?.[field];
      return (
        <div className="tai-diff-field" key={field}>
          <div className="tai-diff-field-key">{GUIDE_INFO_LABELS[field] || field}</div>
          <label className="tai-diff-choice">
            <input
              type="radio"
              name={`guideinfo-${field}`}
              checked={choice === "mine"}
              onChange={() => onFieldChoice(field, "mine")}
            />{" "}
            Mine: {isPhotoField(field) && mineVal ? <img src={mineVal} alt="" className="tai-diff-photo" /> : formatValue(field, mineVal)}
          </label>
          <label className="tai-diff-choice">
            <input
              type="radio"
              name={`guideinfo-${field}`}
              checked={choice === "theirs"}
              onChange={() => onFieldChoice(field, "theirs")}
            />{" "}
            Theirs: {isPhotoField(field) && serverVal ? <img src={serverVal} alt="" className="tai-diff-photo" /> : formatValue(field, serverVal)}
          </label>
        </div>
      );
    })}
  </div>
);

export default GuideInfoDiffCard;
